<style lang="scss" scoped>
.module5 {
  .slide-2 {
    background-color: white;
    background-image: url("../../../assets/module5/slide2/bg-03.jpg");
    background-size: cover;
    background-position: center;
    height: calc(100% - 0px);
  }
}
.heading1 {
  color: #ffffff;
  font-size: 42px;
  line-height: 50px;
}
.left {
  padding-left: 2%;
  padding-right: 5%;
  padding-top: 100px;
  max-width: 708px;
  text-align: center;
}
.right {
  padding-right: 5%;
  padding-left: 0;
}
p {
  color: white;
  margin-bottom: 36px;
}
h1 {
  font-size: 70px;
  margin-top: 100px;
  color: #ffffff;
}
.num {
  color: #c90c0f;
  font-size: 110px;
}
.num-wrap {
  display: flex;
  align-items: center;
  color: white;
  &:nth-of-type(1) {
    transform: translateY(30px);
  }
  &:nth-of-type(2) {
    transform: translateX(180px) translateY(-60px);
  }
  &:nth-of-type(3) {
    transform: translate(85px, -136px);
  }

  .desc {
    width: 177px;
    font-size: 25px;
    margin-bottom: 100px;
    .bt {
      font-size: 72px;
      line-height: 56px;
      margin-top: 15px;
      display: inline-block;
    }
    .c {
      color: #e73048;
    }
  }
}
.bnum {
  font-size: 380px;
}
</style>

<template>
  <div class="slide-2">
    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 1"
        src="@/assets/module5/slide2/green_wave-03.png"
        class="chars delay-3"
      />
    </transition>
    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 1"
        src="@/assets/module5/slide2/purple_wave-03.png"
        class="chars delay-4"
      />
    </transition>
    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 1"
        src="@/assets/module5/slide2/red_wave-03.png"
        class="chars delay-5"
      />
    </transition>
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 1"
        src="@/assets/module5/slide2/face_img-03.png"
        class="chars delay-3"
      />
    </transition>
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 1"
        src="@/assets/module5/slide2/arm_img-03.png"
        class="chars delay-4"
      />
    </transition>
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 1"
        src="@/assets/module5/slide2/speech-03.png"
        class="chars delay-5"
      />
    </transition>
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 1"
        src="@/assets/module5/slide2/timmy-03.png"
        class="chars delay-3"
      />
    </transition>
    <div class="flex">
      <div class="flex-1 left">
        <transition name="scale" appear>
          <div v-show="slideIndex == 1">
            <h2 class="heading1" v-html="$t('module5.slide2.heading1')"></h2>
          </div>
        </transition>
        <transition name="scale" appear>
          <div v-show="slideIndex == 1" class="delay-2">
            <h1 class="heading2" v-html="$t('module5.slide2.heading2')"></h1>
          </div>
        </transition>
      </div>
      <div class="flex-1 right">
        <transition name="fade" appear>
          <div class="delay-5" v-show="slideIndex == 1">
            <div class="num-wrap kooky">
              <div class="bnum kooky">1</div>
              <div class="desc">
                IF SOMEONE’S
                <span class="bt">FACE</span> SUDDENLY DROOPS TO
                <span class="c">ONE</span>
                SIDE
              </div>
            </div>
          </div>
        </transition>

        <transition name="fade" appear>
          <div class="num-wrap kooky delay-6" v-show="slideIndex == 1">
            <div class="bnum kooky">1</div>
            <div class="desc">
              IF SOMEONE SUDDENLY
              <br />LOSES <br />POWER <br />IN
              <span class="c">ONE</span>
              <span class="bt">ARM</span>
            </div>
          </div>
        </transition>

        <transition name="fade" appear>
          <div class="num-wrap kooky delay-7" v-show="slideIndex == 1">
            <div class="bnum kooky">2</div>
            <div class="desc">
              IF
              <span class="c">TWO</span> INCOHERENT LIPS SUDDENLY AFFECT THEIR
              <span class="bt">SPEECH</span>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
